import { Injectable, NgZone } from "@angular/core";
import { StorageService } from "../services/storage.service";
import { HttpClient } from "@angular/common/http";
import { AppGpSettings } from "./settings.service";
import { lastValueFrom } from "rxjs";
import { Router } from "@angular/router";
/**
 *  Metodo para realizar llamado a funcion nativa
 * con la que obtiene tokensso
 */
declare function getSSOToken(): any;

/**
 * Servicio que carga al inicializar la app
 */
@Injectable()
export class AppLoadService {
  /**
   * Inicializa servicios
   * @param storageService
   * @param http
   */
  constructor(
    private storageService: StorageService,
    private http: HttpClient,
    private zone: NgZone,
    private router: Router,
  ) {
    this.setupSSOListener();
    this.clearStorage();
    getSSOToken();
  }

  setupSSOListener(): void {
    (window as any).angularCatalogInit = {
      zone: this.zone,
      getSSOTokenDone: (token) => this.receiveTokenSSO(token),
      component: this,
    };
  }

  clearStorage(): void {
    window.localStorage.clear();
    this.storageService.clearAll();
  }

  receiveTokenSSO(token: string) {
    this.storageService.set("token", token);
  }

  /**
   * metodo para carga de app
   */
  async initializeApp(): Promise<void> {
    this.storageService.set("Version", "1.0.0");
    await new Promise<void>((resolve) => {
      setTimeout(() => {resolve()}, 3000)
    });
  }

  /**
   * Obtiene las configuraciones para poder cargar la app dependiendo el entorno
   */

  async getSettings(): Promise<any> {
    try {
      const route = window.location.pathname;
      if (route !== '/history') {
        this.router.navigateByUrl('/history');
      }
      const res: any = await lastValueFrom(this.http.get("/config.json"));
      this.setEnvironmentVariables(res);
    } catch {
      this.setEnvironmentVariables(AppGpSettings);
    }
  }

  setEnvironmentVariables(config: any) {    
    this.storageService.set("ENV", config.ENV_VAR);
    this.storageService.set("ENV_TAGGEO", config.ENV_TAGGEO);
    this.storageService.set("CHANNELID", config.CHANNELID);
    this.storageService.set("SOURCE", config.SOURCE);
    this.storageService.set("HOST", config.URL);
  }
}
